import React from 'react';
import { toast } from 'react-toastify';
import MagicButton from 'components/MagicButton/MagicButton';
import { useUnblockUserMutation } from 'store/services/block/blockApi';
import './ProfileRestrictedMessage.css';

interface ProfileRestrictedMessageProps {
  userId: number;
  username: string;
  viewerHasBlocked: boolean;
}

// Replaces the profile tabs (trade history, want list, have list, trophy case)
// when a block restricts the profile. The non-blocker viewer must only ever see
// a generic private-profile message — never any block language.
export const ProfileRestrictedMessage: React.FC<ProfileRestrictedMessageProps> = ({
  userId,
  username,
  viewerHasBlocked,
}) => {
  const [unblockUser, { isLoading }] = useUnblockUserMutation();

  const handleUnblock = async () => {
    try {
      await unblockUser({ userId, username }).unwrap();
      toast.success(`${username} has been unblocked.`);
    } catch (error) {
      console.error('Failed to unblock user:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  if (!viewerHasBlocked) {
    return (
      <div className="profile-restricted">
        <div className="profile-restricted-icon">&#128274;</div>
        <p className="profile-restricted-description">
          This profile is currently private.
        </p>
      </div>
    );
  }

  return (
    <div className="profile-restricted">
      <div className="profile-restricted-icon">&#128274;</div>
      <p className="profile-restricted-description">
        You blocked {username}. Unblock to view profile.
      </p>
      <div className="profile-restricted-action">
        <MagicButton
          label={isLoading ? 'Unblocking...' : 'Unblock'}
          color="purple"
          onPress={handleUnblock}
          isLoading={isLoading}
          isDisabled={isLoading}
          fullWidth={false}
        />
      </div>
    </div>
  );
};

export default ProfileRestrictedMessage;
